import { apiGet } from 'api';
import { GetConsultationsRequest, GetConsultationsResponse } from '../../types';

export const getConsultations = (
  request: GetConsultationsRequest
): Promise<GetConsultationsResponse> =>
  apiGet<GetConsultationsResponse, GetConsultationsRequest>('consultations', request);
